import { Box } from '@material-ui/core';
import React from 'react';
import { usePaymentProviderContext } from '../../Session';
import { ContainerModern } from '../common';
import { Typography } from '../common/Typography';
import { LicenseLayout } from './LicenseLayout';
import { NewLicenseKey } from './NewLicenseKey';
import { useLicences } from './useLicences';
import { compact } from 'lodash-es';
import { dummyLicense } from './dummyData';

export const SubscriptionView: React.FC = () => {
  const { paymentProvider } = usePaymentProviderContext();
  const accountNumber =
    paymentProvider && 'accountNumber' in paymentProvider ? paymentProvider.accountNumber : '';
  const { data = [], isFetching, refetch } = useLicences({ keepPreviousData: true });

  const licenses = compact([isFetching && dummyLicense, ...data]);

  const onComplete = () => refetch();

  return (
    <ContainerModern>
      <Box mb={4}>
        <Typography variant='h3' color='textPrimary'>
          Your account number: {accountNumber}
        </Typography>
      </Box>
      <Box mb={2}>
        <NewLicenseKey onComplete={onComplete} />
      </Box>
      {licenses.map((license) => (
        <Box mb={4} key={license.id}>
          <LicenseLayout license={license} />
        </Box>
      ))}
    </ContainerModern>
  );
};
